import smoothscroll from 'smoothscroll-polyfill';

/* global _as_rest */
/* eslint camelcase: 0 */

smoothscroll.polyfill();

export const reformatPostCode = postcode => {
  // eslint-disable-next-line yoda
  if (typeof postcode !== 'string') {
    return postcode;
  }

  return postcode
    .toUpperCase()
    .replace(/ /g, '')
    .replace(/.{3}$/, ' $&');
};

export const removeAllVuePreloadHiddenClasses = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-preload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].classList.remove(className);
  }
};

export const removeAllVuePostloadHiddenElements = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-postload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].parentNode.removeChild(elements[i]);
  }
};

// eslint-disable-next-line no-unused-vars
const getOffsetTop = element => {
  let offsetTop = 0;

  // eslint-disable-next-line no-cond-assign
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while (element = element.offsetParent);

  return offsetTop;
};

const delay = duration => new Promise(resolve => {
  setTimeout(() => {
    resolve();
  }, duration);
});

const scrollToElement = async selector => {
  await delay(25);
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'start'
  });
};

export const scrollToStep = name => {
  scrollToElement(`[data-sc-step="${name}"]`);
};

export const scrollToFirstError = () => {
  scrollToElement('.has-error');
};
